module.exports = __webpack_public_path__ + "mo/img/mo-4-logo.5fb6b941.png";